export { default as Logo } from './Logo';



// WEBPACK FOOTER //
// ./src/components/Footer/Logo/index.ts